import ApiService from '../../../../shared/services/ApiService';

export default{
    getPublicHolidays(countryId) {
        return ApiService.get(`holidays/${countryId}/company`)
    },
    addCustomHolidays(data){
        return ApiService.post(`holidays-multi-store`, data)
    },
    deleteHoliday(id, type){
        return ApiService.delete(`holidays/${id}/${type}/`)
    },
    getCountries(){
        return ApiService.get('holiday-country-list')
    },
    updateSelectedCountry(data){
        return ApiService.post('user-settings-country',data)
    }
}